import { useEffect, useState } from "react";




export default function JazzHero({ isVisible: controlledVisible }) {
  const [internalVisible, setInternalVisible] = useState(false);

  useEffect(() => {
    if (controlledVisible !== undefined) {
      if (controlledVisible) {
        // Small delay to synchronize with homepage opacity transition
        const timer = setTimeout(() => setInternalVisible(true), 150);
        return () => clearTimeout(timer);
      } else {
        setInternalVisible(false);
      }
    } else {
      setInternalVisible(true);
    }
  }, [controlledVisible]);

  const isVisible = controlledVisible !== undefined ? internalVisible : true;

  const heroImages = [
    {
      src: "/static/images/hero_image_4.png",
      alt: "Temidayo Balogun",
      className: "image-1",
    },
    {
      src: "/static/images/hero_image_5.png",
      alt: "Temidayo Balogun",
      className: "image-2",
    },
    {
      src: "/static/images/hero_image_3.png",
      alt: "Temidayo Balogun",
      className: "image-3",
    },
    {
      src: "/static/images/hero_image_1.png",
      alt: "Temidayo Balogun",
      className: "image-4",
    },
    {
      src: "/static/images/hero_image_2.png",
      alt: "Temidayo Balogun",
      className: "image-5",
    },
    {
      src: "/static/images/hero_image_6.JPG",
      alt: "Temidayo Balogun",
      className: "image-6",
    },
  ];

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white pt-20 sm:pt-24 lg:pt-0"
      style={{
        fontFamily: "Playfair Display, Georgia, serif",
      }}
    >
      {/* Background pattern - subtle jazz-inspired lines */}
      <div className="absolute inset-0 opacity-[0.03]">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern
              id="jazz-lines"
              x="0"
              y="0"
              width="100"
              height="100"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M0 50 Q 25 25, 50 50 T 100 50"
                stroke="black"
                fill="none"
                strokeWidth="1"
              />
              <path
                d="M0 70 Q 25 45, 50 70 T 100 70"
                stroke="black"
                fill="none"
                strokeWidth="0.5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#jazz-lines)" />
        </svg>
      </div>

      {/* Mobile Image Display - Shows on mobile only */}
      <div className="lg:hidden absolute top-24 left-0 right-0 px-4 pointer-events-none overflow-hidden">
        <div className="relative w-full max-w-[340px] sm:max-w-[400px] mx-auto h-[200px]">
          {/* Mobile Image 1 - Top left */}
          <div
            className={`absolute top-0 left-[5%] w-[140px] transition-all duration-1000 ${isVisible ? "opacity-90 translate-y-0" : "opacity-0 translate-y-8"
              }`}
            style={{
              transform: isVisible
                ? "rotate(-8deg)"
                : "rotate(-8deg) translateY(20px)",
              transitionDelay: "300ms",
              zIndex: 3,
            }}
          >
            <div className="bg-white p-2 pb-6 shadow-[0_8px_20px_rgba(0,0,0,0.15)]">
              <img
                src={heroImages[0].src}
                alt={heroImages[0].alt}
                className="w-full h-[120px] object-cover"
              />
            </div>
          </div>

          {/* Mobile Image 2 - Center right */}
          <div
            className={`absolute top-[20px] right-[8%] w-[150px] transition-all duration-1000 ${isVisible ? "opacity-90 translate-y-0" : "opacity-0 translate-y-8"
              }`}
            style={{
              transform: isVisible
                ? "rotate(6deg)"
                : "rotate(6deg) translateY(20px)",
              transitionDelay: "500ms",
              zIndex: 4,
            }}
          >
            <div className="bg-white p-2 pb-6 shadow-[0_8px_20px_rgba(0,0,0,0.15)]">
              <img
                src={heroImages[1].src}
                alt={heroImages[1].alt}
                className="w-full h-[130px] object-cover"
              />
            </div>
          </div>

          {/* Mobile Image 3 - Bottom center */}
          <div
            className={`absolute top-[90px] left-[25%] w-[135px] transition-all duration-1000 ${isVisible ? "opacity-90 translate-y-0" : "opacity-0 translate-y-8"
              }`}
            style={{
              transform: isVisible
                ? "rotate(-3deg)"
                : "rotate(-3deg) translateY(20px)",
              transitionDelay: "700ms",
              zIndex: 5,
            }}
          >
            <div className="bg-white p-2 pb-6 shadow-[0_8px_20px_rgba(0,0,0,0.15)]">
              <img
                src={heroImages[2].src}
                alt={heroImages[2].alt}
                className="w-full h-[115px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Dynamic Image Collage - Hidden on mobile, visible on lg+ */}
      <div className="hidden lg:block absolute left-0 top-10 bottom-0 w-[45%] pointer-events-none">
        <div className="relative w-full h-full opacity-90">
          {/* Image 1 - Top left, rotated */}
          <div className="image-card image-1 absolute top-[8%] left-[5%] w-[220px] h-[280px] md:w-[260px] md:h-[320px]">
            <div className="image-frame">
              <img
                src={heroImages[0].src}
                alt={heroImages[0].alt}
                className="image-content"
              />
            </div>
          </div>

          {/* Image 2 - Center left, rotated opposite */}
          <div className="image-card image-2 absolute top-[35%] left-[12%] w-[180px] h-[240px] md:w-[220px] md:h-[280px]">
            <div className="image-frame">
              <img
                src={heroImages[1].src}
                alt={heroImages[1].alt}
                className="image-content"
              />
            </div>
          </div>

          {/* Image 3 - Bottom left */}
          <div className="image-card image-3 absolute bottom-[10%] left-[8%] w-[200px] h-[260px] md:w-[240px] md:h-[300px]">
            <div className="image-frame">
              <img
                src={heroImages[2].src}
                alt={heroImages[2].alt}
                className="image-content"
              />
            </div>
          </div>

          {/* Image 4 - Top center (overlapping) */}
          <div className="image-card image-4 absolute top-[15%] left-[30%] w-[160px] h-[200px] md:w-[200px] md:h-[250px]">
            <div className="image-frame">
              <img
                src={heroImages[3].src}
                alt={heroImages[3].alt}
                className="image-content"
              />
            </div>
          </div>

          {/* Image 5 - Middle overlapping */}
          <div className="image-card image-5 absolute top-[45%] left-[35%] w-[190px] h-[240px] md:w-[230px] md:h-[280px]">
            <div className="image-frame">
              <img
                src={heroImages[4].src}
                alt={heroImages[4].alt}
                className="image-content"
              />
            </div>
          </div>

          {/* Image 6 - Small accent piece */}
          <div className="image-card image-6 absolute bottom-[25%] left-[40%] w-[140px] h-[180px] md:w-[180px] md:h-[220px]">
            <div className="image-frame">
              <img
                src={heroImages[5].src}
                alt={heroImages[5].alt}
                className="image-content"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 sm:px-6 text-center max-w-[1200px] mx-auto lg:ml-auto lg:mr-12 lg:w-[55%] py-12 sm:py-16 lg:py-8">
        {/* Artist Name - Responsive sizing with extra top margin on mobile */}
        <h1
          className={`text-black font-normal mb-4 sm:mb-6 mt-[240px] sm:mt-[200px] lg:mt-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          style={{
            fontSize: "clamp(36px, 10vw, 120px)",
            letterSpacing: "-0.02em",
            lineHeight: "0.95",
            fontWeight: 300,
          }}
        >
          TEMIDAYO BALOGUN
        </h1>

        {/* Decorative line */}
        <div
          className={`w-16 sm:w-24 h-[2px] bg-jazz-brown mx-auto mb-6 sm:mb-8 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"
            }`}
        />

        {/* Tagline */}
        <p
          className={`text-black/80 text-base sm:text-lg md:text-xl mb-8 sm:mb-10 max-w-[700px] mx-auto px-4 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          style={{
            fontFamily: "Crimson Pro, Georgia, serif",
            fontStyle: "italic",
            fontWeight: 400,
            lineHeight: "1.6",
            letterSpacing: "0.3px",
          }}
        >
          As an artist and seeker, Temidayo weaves the diverse cultural
          practices of the Yoruba people into his compositions, grounding his
          sound in the rhythms and harmonies of West Africa.
        </p>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 max-w-md mx-auto transition-all duration-1000 delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
        >
          <a
            href="#discography"
            className="group bg-jazz-brown text-white px-6 sm:px-8 py-3 sm:py-4 transition-all duration-300 hover:bg-white hover:text-jazz-brown hover:shadow-[0_8px_24px_rgba(139,94,60,0.3)] text-center touch-manipulation border border-jazz-brown"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "13px",
              fontWeight: 600,
              letterSpacing: "1px",
            }}
          >
            LISTEN NOW
          </a>

          <a
            href="#events"
            className="group border-2 border-jazz-brown text-jazz-brown px-6 sm:px-8 py-3 sm:py-4 hover:bg-jazz-brown hover:text-white transition-all duration-300 text-center touch-manipulation"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "13px",
              fontWeight: 600,
              letterSpacing: "1px",
            }}
          >
            UPCOMING EVENTS
          </a>
        </div>

        {/* Scroll indicator - hidden on mobile and large screens */}
        <div
          className={`hidden sm:block lg:hidden absolute bottom-12 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-1000 ${isVisible ? "opacity-100" : "opacity-0"
            }`}
        >
          <div className="flex flex-col items-center gap-2">
            <span
              className="text-xs text-black/85 uppercase tracking-widest"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "10px",
                fontWeight: 600,
              }}
            >
              Scroll
            </span>
            <div className="w-[1px] h-12 bg-black/40 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-8 bg-black/60 animate-scroll" />
            </div>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        /* Image card styling */
        .image-card {
          filter: grayscale(30%);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .image-card:hover {
          filter: grayscale(0%);
          z-index: 20 !important;
        }

        .image-frame {
          width: 100%;
          height: 100%;
          background: white;
          padding: 12px;
          padding-bottom: 40px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          border: 1px solid rgba(0, 0, 0, 0.1);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .image-card:hover .image-frame {
          transform: translateY(-8px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
        }

        .image-content {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* Individual image animations with different timings */
        .image-1 {
          transform: rotate(-8deg);
          z-index: 6;
          animation: floatIn1 1.2s ease-out forwards, float1 8s ease-in-out 1.2s infinite;
          opacity: 0;
        }

        .image-2 {
          transform: rotate(5deg);
          z-index: 8;
          animation: floatIn2 1.4s ease-out 0.2s forwards, float2 9s ease-in-out 1.6s infinite;
          opacity: 0;
        }

        .image-3 {
          transform: rotate(-3deg);
          z-index: 7;
          animation: floatIn3 1.3s ease-out 0.4s forwards, float3 7.5s ease-in-out 1.7s infinite;
          opacity: 0;
        }

        .image-4 {
          transform: rotate(12deg);
          z-index: 5;
          animation: floatIn4 1.5s ease-out 0.1s forwards, float4 10s ease-in-out 1.6s infinite;
          opacity: 0;
        }

        .image-5 {
          transform: rotate(-6deg);
          z-index: 9;
          animation: floatIn5 1.6s ease-out 0.3s forwards, float5 8.5s ease-in-out 1.9s infinite;
          opacity: 0;
        }

        .image-6 {
          transform: rotate(15deg);
          z-index: 4;
          animation: floatIn6 1.4s ease-out 0.5s forwards, float6 9.5s ease-in-out 1.9s infinite;
          opacity: 0;
        }

        /* Float in animations - slide from different directions */
        @keyframes floatIn1 {
          0% {
            opacity: 0;
            transform: rotate(-8deg) translateX(-100px) translateY(-50px);
          }
          100% {
            opacity: 1;
            transform: rotate(-8deg) translateX(0) translateY(0);
          }
        }

        @keyframes floatIn2 {
          0% {
            opacity: 0;
            transform: rotate(5deg) translateX(-80px) translateY(60px);
          }
          100% {
            opacity: 1;
            transform: rotate(5deg) translateX(0) translateY(0);
          }
        }

        @keyframes floatIn3 {
          0% {
            opacity: 0;
            transform: rotate(-3deg) translateX(-120px) translateY(80px);
          }
          100% {
            opacity: 1;
            transform: rotate(-3deg) translateX(0) translateY(0);
          }
        }

        @keyframes floatIn4 {
          0% {
            opacity: 0;
            transform: rotate(12deg) translateX(-60px) translateY(-80px);
          }
          100% {
            opacity: 1;
            transform: rotate(12deg) translateX(0) translateY(0);
          }
        }

        @keyframes floatIn5 {
          0% {
            opacity: 0;
            transform: rotate(-6deg) translateX(-90px) translateY(40px) scale(0.8);
          }
          100% {
            opacity: 1;
            transform: rotate(-6deg) translateX(0) translateY(0) scale(1);
          }
        }

        @keyframes floatIn6 {
          0% {
            opacity: 0;
            transform: rotate(15deg) translateX(-70px) translateY(-40px) scale(0.9);
          }
          100% {
            opacity: 1;
            transform: rotate(15deg) translateX(0) translateY(0) scale(1);
          }
        }

        /* Continuous floating animations */
        @keyframes float1 {
          0%, 100% {
            transform: rotate(-8deg) translateY(0px);
          }
          50% {
            transform: rotate(-8deg) translateY(-12px);
          }
        }

        @keyframes float2 {
          0%, 100% {
            transform: rotate(5deg) translateY(0px) translateX(0px);
          }
          33% {
            transform: rotate(5deg) translateY(-8px) translateX(5px);
          }
          66% {
            transform: rotate(5deg) translateY(-15px) translateX(-5px);
          }
        }

        @keyframes float3 {
          0%, 100% {
            transform: rotate(-3deg) translateY(0px);
          }
          50% {
            transform: rotate(-3deg) translateY(-10px);
          }
        }

        @keyframes float4 {
          0%, 100% {
            transform: rotate(12deg) translateY(0px) translateX(0px);
          }
          50% {
            transform: rotate(12deg) translateY(-14px) translateX(8px);
          }
        }

        @keyframes float5 {
          0%, 100% {
            transform: rotate(-6deg) translateY(0px) translateX(0px);
          }
          33% {
            transform: rotate(-6deg) translateY(-10px) translateX(-6px);
          }
          66% {
            transform: rotate(-6deg) translateY(-5px) translateX(6px);
          }
        }

        @keyframes float6 {
          0%, 100% {
            transform: rotate(15deg) translateY(0px);
          }
          50% {
            transform: rotate(15deg) translateY(-8px);
          }
        }

        @keyframes scroll {
          0% {
            transform: translateY(-100%);
          }
          100% {
            transform: translateY(200%);
          }
        }

        .animate-scroll {
          animation: scroll 2s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
